import React from 'react';
import AxonIcon from '../icons/axon-icon';

export default class MarketingSearchTabs extends React.Component {
    render() {
        const { activeTab, onTabChange } = this.props;

        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '12px',
                animation: 'fade-up 700ms cubic-bezier(0.16, 1, 0.3, 1) 350ms both'
            }}>
                <div className="nav-tabs">
                    <button
                        className={`nav-tab ${activeTab === 'database' ? 'active' : ''}`}
                        onClick={() => onTabChange('database')}
                        style={{ border: 'none', cursor: 'pointer' }}
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <ellipse cx="12" cy="5" rx="9" ry="3"/>
                            <path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/>
                            <path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/>
                        </svg>
                        Search Database
                    </button>
                    <button
                        className={`nav-tab ${activeTab === 'axon' ? 'active' : ''}`}
                        onClick={() => onTabChange('axon')}
                        style={{ border: 'none', cursor: 'pointer' }}
                    >
                        <AxonIcon size={16} />
                        Chat with Axon
                    </button>
                </div>
            </div>
        );
    }
}
